"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContentWarning;
exports.checkWarningCookie = checkWarningCookie;
const react_1 = __importDefault(require("react"));
const js_cookie_1 = __importDefault(require("js-cookie"));
function ContentWarning({ link, track, close, onDownload, variant, warning, id }) {
    const closeAfterDelay = react_1.default.useCallback((event) => {
        const key = cookieKey(id);
        if (onDownload) {
            onDownload(event);
        }
        js_cookie_1.default.set(key, 'true', { expires: 28 });
        window.setTimeout(close, 200);
    }, [close, onDownload, id]);
    return (react_1.default.createElement("div", { className: "give-before-pdf" },
        react_1.default.createElement("div", { className: "text-content" }, warning),
        react_1.default.createElement("a", Object.assign({ href: link }, (track ? { 'data-track': track } : {}), { onClick: closeAfterDelay, className: "btn go-to" }),
            "Go to your ",
            variant === 'View online' ? 'book' : 'file')));
}
function cookieKey(id) {
    return `content-warning-${id}`;
}
function checkWarningCookie(id) {
    return js_cookie_1.default.get(id);
}
